import { cn } from './cn'

/** Caixa visual compartilhada por Input, SelectTrigger, Combobox e DatePicker (raio 8). */
export const fieldBoxClasses = cn(
  'flex h-9 w-full min-w-0 items-center gap-2 rounded-md border border-border bg-surface-2 px-3 text-body text-ink',
  'aria-invalid:border-framboesa data-invalid:border-framboesa',
  'disabled:cursor-not-allowed disabled:opacity-60 data-disabled:cursor-not-allowed data-disabled:opacity-60',
)

/** Superfície flutuante (popover, menus, listas): borda + sombra float, raio 12. */
export const floatingSurfaceClasses = cn(
  'z-50 rounded-lg border border-border bg-surface text-ink shadow-float outline-none',
  'data-[state=open]:animate-float-in data-[state=closed]:animate-float-out',
)

const itemBase =
  'relative flex min-h-8 cursor-default items-center gap-2 rounded-sm px-2 text-body text-ink outline-none select-none [&_svg]:size-4 [&_svg]:shrink-0'

/**
 * Item de lista flutuante do Radix (Select, DropdownMenu). O destaque em petróleo suave é o
 * indicador de foco desses itens. O Radix só põe `data-disabled` quando o item está
 * desabilitado, então a presença do atributo basta.
 */
export const floatingItemClasses = cn(
  itemBase,
  'data-highlighted:bg-petroleo-soft',
  'data-disabled:pointer-events-none data-disabled:text-ink-3',
)

/**
 * Item do cmdk (Combobox, CommandPalette). O cmdk escreve `data-disabled="false"` e
 * `data-selected="false"` em todo item, então o valor precisa ser comparado: com
 * `data-disabled:` (só presença) todos os itens ficariam inertes.
 */
export const commandItemClasses = cn(
  itemBase,
  'data-[selected=true]:bg-petroleo-soft',
  'data-[disabled=true]:pointer-events-none data-[disabled=true]:text-ink-3',
)
